// Therapy goal categories — keep aligned with backend `GOAL_CATEGORIES` list.
// Used for the category dropdown on Child Profile + filtering in Weekly Focus.
export const GOAL_CATEGORIES = [
  { slug: 'expressive',          label: 'Expressive Language',  color: 'bg-blue-100 text-blue-700 border-blue-200' },
  { slug: 'receptive',           label: 'Receptive Language',   color: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
  { slug: 'speech_motor',        label: 'Speech / Motor',        color: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200' },
  { slug: 'auditory_processing', label: 'Auditory Processing',   color: 'bg-amber-100 text-amber-700 border-amber-200' },
  { slug: 'pragmatic',           label: 'Pragmatic / Social',    color: 'bg-rose-100 text-rose-700 border-rose-200' },
  { slug: 'fluency',             label: 'Fluency',               color: 'bg-cyan-100 text-cyan-700 border-cyan-200' },
  { slug: 'aac',                 label: 'AAC',                   color: 'bg-teal-100 text-teal-700 border-teal-200' },
  { slug: 'feeding',             label: 'Feeding / Swallowing',  color: 'bg-orange-100 text-orange-700 border-orange-200' },
  { slug: 'social_emotional',    label: 'Social / Emotional',    color: 'bg-violet-100 text-violet-700 border-violet-200' },
  { slug: 'literacy',             label: 'Literacy',              color: 'bg-indigo-100 text-indigo-700 border-indigo-200' },
  { slug: 'other',               label: 'Other',                 color: 'bg-stone-100 text-stone-700 border-stone-200' },
];

export const GOAL_CATEGORY_MAP = Object.fromEntries(GOAL_CATEGORIES.map((c) => [c.slug, c]));

export const getCategoryMeta = (slug) =>
  GOAL_CATEGORY_MAP[slug] || GOAL_CATEGORY_MAP.other;
